export const DropdownTypes = {
	DROPDOWN: 'dropdown',
};
